import { render, staticRenderFns } from "./PwbAttributes.vue?vue&type=template&id=5c84e448&scoped=true"
import script from "./PwbAttributes.vue?vue&type=script&lang=js"
export * from "./PwbAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c84e448",
  null
  
)

export default component.exports